export default "__VITE_ASSET__2T$ajZzO__"